<!-- AG一般ユーザー登録・変更 一覧画面-->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">ユーザー登録・編集</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <!-- 検索条件 -->
      <div class="">
        <table style="width: 100%">
          <thead>
            <th style="width: 14%"></th>
            <th style="width: 18%"></th>
            <th style="width: 6%"></th>
            <th style="width: 16%"></th>
            <th style="width: 6%"></th>
            <th style="width: 16%"></th>
            <th style="width: 8%"></th>
            <th style="width: 16%"></th>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                エージェントコード
              </td>
              <td>
                <select
                  id="agCode"
                  v-model="agUserSearchCond.agCode"
                  v-bind:disabled="!isAgCodeDataListMultiple || !isSearchMode"
                  class="form-control"
                >
                  <option
                    v-for="item in agCodeDataList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.value + " " + item.text }}
                  </option>
                </select>
              </td>
              <td class="form-control-title">会社名</td>
              <td>
                <input
                  id="kaisyaName"
                  v-model="agUserSearchCond.kaisyaName"
                  type="text"
                  placeholder="会社名"
                  maxlength="255"
                  class="form-control"
                />
              </td>
              <td class="form-control-title">部署名</td>
              <td>
                <input
                  id="busyoName"
                  v-model="agUserSearchCond.busyoName"
                  type="text"
                  placeholder="部署名"
                  maxlength="255"
                  class="form-control"
                />
              </td>
              <td class="form-control-title">担当者名</td>
              <td>
                <input
                  id="tantousyaName"
                  v-model="agUserSearchCond.tantousyaName"
                  type="text"
                  placeholder="担当者名"
                  maxlength="255"
                  class="form-control"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <table style="width: 100%">
          <thead>
            <th style="width: 11%"></th>
            <th style="width: 26%"></th>
            <th style="width: 6%"></th>
            <th style="width: 21%"></th>
            <th style="width: 6%"></th>
            <th style="width: 21%"></th>
            <th style="width: 9%"></th>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">メールアドレス</td>
              <td>
                <input
                  id="email"
                  v-model="agUserSearchCond.email"
                  type="text"
                  placeholder="メールアドレス"
                  maxlength="255"
                  class="form-control"
                />
              </td>
              <td class="form-control-title">備考１</td>
              <td>
                <input
                  id="bikou1"
                  v-model="agUserSearchCond.bikou1"
                  type="text"
                  placeholder="備考１"
                  maxlength="255"
                  class="form-control"
                />
              </td>
              <td class="form-control-title">備考２</td>
              <td>
                <input
                  id="bikou2"
                  v-model="agUserSearchCond.bikou2"
                  type="text"
                  placeholder="備考２"
                  maxlength="255"
                  class="form-control"
                />
              </td>
              <td class="form-control-title">
                <button
                  type="button"
                  name="btnSearch"
                  class="btn btn-primary"
                  @click="onSearch"
                >
                  検索
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <!-- 検索結果 -->
      <div class="">
        <label class="">件数：</label>
        <label class="" v-if="!isSearchMode">
          {{ agUserDataList.length.toLocaleString() }} 件
        </label>
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_btnUpdate">編集</th>
              <th
                :class="[
                  'col_kaisyaName',
                  'sortable',
                  isDirectionASC('kaisyaName') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('kaisyaName')"
              >
                会社名
              </th>
              <th
                :class="[
                  'col_busyoName',
                  'sortable',
                  isDirectionASC('busyoName') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('busyoName')"
              >
                部署名
              </th>
              <th
                :class="[
                  'col_tantousyaName',
                  'sortable',
                  isDirectionASC('tantousyaName') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('tantousyaName')"
              >
                担当者名
              </th>
              <th
                :class="[
                  'col_email',
                  'sortable',
                  isDirectionASC('email') ? 'asc' : 'desc',
                ]"
                @click="onSortItem('email')"
              >
                メールアドレス
              </th>
              <th class="col_bikou1">備考１</th>
              <th class="col_bikou2">備考２</th>
              <th class="col_roleDisplayName">権限</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in paginatedData" :key="item.userId">
              <td data-name="mSelection" style="text-align: center">
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                />
              </td>
              <td data-name="mBtnUpdate" style="text-align: center">
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  @click="showUpdate(item.userId)"
                >
                  編集
                </button>
              </td>
              <td data-name="mKaisyaName">{{ item.kaisyaName }}</td>
              <td data-name="mBusyoName">{{ item.busyoName }}</td>
              <td data-name="mTantousyaName">{{ item.tantousyaName }}</td>
              <td data-name="mEmail">{{ item.email }}</td>
              <td data-name="mBikou1">{{ item.bikou1 }}</td>
              <td data-name="mBikou2">{{ item.bikou2 }}</td>
              <td data-name="mKanriKengen">{{ item.roleDisplayName }}</td>
            </tr>
          </tbody>
        </table>
        <content-pagination
          :current-page="currentPage"
          :total-pages="totalPages"
          :items-per-page="itemsPerPage"
          @page-changed="handlePageChange"
        />
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
              v-bind:disabled="isSearchMode"
            >
              削除
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>

            <button
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              @click="onClear"
            >
              クリア
            </button>

            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="showAdd"
              v-bind:disabled="isSearchMode"
            >
              新規登録
            </button>
          </div>
        </div>
        <div>
          <p style="text-align: right">
            ※：エージェントコード変更して検索する場合もクリアボタンを押下してください。
          </p>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>
<script lang="ts">
import { defineComponent, PropType, computed, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import ContentPagination from "../controls/ContentPagination.vue";
import { useRouter, useRoute } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import {
  formatMessage,
  sanitizeInput,
  isTokenAlive,
  commonHandleAxiosError,
} from "@/Common";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";

interface selectItem {
  value: string;
  text: string;
}

interface agUserSearchCond {
  agCode: string;
  kaisyaName: string;
  busyoName: string;
  tantousyaName: string;
  email: string;
  bikou1: string;
  bikou2: string;
}

interface agUserData {
  selection: boolean;
  agCode: string;
  userId: string;
  kaisyaName: string;
  busyoName: string;
  tantousyaName: string;
  email: string;
  bikou1: string;
  bikou2: string;
  roleDisplayName: string;
}

interface sortItem {
  key: string;
  direction: string;
}

class AgUserListConstants {
  // ------------------------------------------------------------
  // AG一般ユーザー登録・変更 一覧画面の処理モード
  static readonly PROCESSING_MODE_SERACH = "SERACH"; // 検索条件入力
  static readonly PROCESSING_MODE_RESULT = "RESULT"; // 検索結果表示

  // ソート種別
  static readonly SORT_TYPE_ASC = "ASC"; // 昇順
  static readonly SORT_TYPE_DESC = "DESC"; // 降順
}

export default defineComponent({
  name: "AgUserMaintenanceListComponent",
  props: {
    isResearch: {
      type: String as PropType<string>,
    },
    isResearch2: {
      type: Boolean as PropType<boolean>,
    },
  },
  components: {
    HeaderComponent,
    FooterComponent,
    ContentPagination,
    BackToTop,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { logoutUser } = useUserStore();
    const { getCategoryIdByName } = useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref("");
    const agCode = ref("");
    const userId = ref("");
    const categoryId = ref<string | null>(null);
    const isKaunetAdmin = ref(false);
    const agCodeDataList = ref<selectItem[]>([]);
    const agUserSearchCond = ref<agUserSearchCond>({
      agCode: "",
      kaisyaName: "",
      busyoName: "",
      tantousyaName: "",
      email: "",
      bikou1: "",
      bikou2: "",
    });
    const agUserDataList = ref<agUserData[]>([]);
    const agUserSortItemList = ref<sortItem[]>([]);
    const processingMode = ref("");
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(15); // 1ページに表示する最大件数
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const isResearch = computed(() => {
      return (
        route.query.isResearch &&
        String(route.query.isResearch).toLowerCase() === "true"
      );
    }); // 再検索フラグ

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
        isKaunetAdmin.value = parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;
      }
      // カテゴリID取得
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_AG_USER_TOUROKU
      );

      // 処理中フラグON
      processingStore.isProcessing = true;

      // 初期情報取得
      try {
        const response = await apiAuthClient.post("/api/AgUser", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value,
        });

        // AGコードコンボボックス設定
        agCodeDataList.value = response.data.agCodeList;

        // AGコードコンボボックス初期選択
        agUserSearchCond.value.agCode = agCode.value;

        // sessionStorageから検索条件復元
        if (isResearch.value) {
          const searchCond = sessionStorage.getItem(
            AppConstants.AGUSER_SEARCH_SESSION_NAME
          );
          if (searchCond) {
            agUserSearchCond.value = JSON.parse(searchCond) as agUserSearchCond;
          }
        }

        // AG一般ユーザー一覧情報取得
        await getAgUserList();
        // 先頭ページ表示
        currentPage.value = 1;

        isInitError.value = false;
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * 検索ボタン押下
     */
    const onSearch = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チエック
      if (!agUserSearchCond.value.agCode) {
        errorMessage.value = formatMessage(
          messages.ERR_0003,
          "エージェントコード"
        );
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // AG一般ユーザー一覧情報取得
      try {
        await getAgUserList();
        // 先頭ページ表示
        currentPage.value = 1;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * AG一般ユーザー一覧情報取得
     */
    const getAgUserList = async () => {
      const response = await apiAuthClient.post("/api/AgUser/getAgUserList", {
        systemKbn: AppConstants.SYSTEM_KBN_WITH,
        agCode: agCode.value,
        userId: userId.value,
        categoryId: categoryId.value,
        // agUserSearchCond: sanitizeSearchCond.value,
        agUserSearchCond: {
          agCode: agUserSearchCond.value.agCode,
          kaisyaName: sanitizeInput(agUserSearchCond.value.kaisyaName),
          busyoName: sanitizeInput(agUserSearchCond.value.busyoName),
          tantousyaName: sanitizeInput(agUserSearchCond.value.tantousyaName),
          email: sanitizeInput(agUserSearchCond.value.email),
          bikou1: sanitizeInput(agUserSearchCond.value.bikou1),
          bikou2: sanitizeInput(agUserSearchCond.value.bikou2),
        },
      });

      // 検索条件をsessionStorageに保存
      sessionStorage.setItem(
        AppConstants.AGUSER_SEARCH_SESSION_NAME,
        JSON.stringify(agUserSearchCond.value)
      );

      // レスポンスを保持
      agUserDataList.value = response.data.agUserDataList;
      // 処理モード設定
      processingMode.value = AgUserListConstants.PROCESSING_MODE_RESULT;
      // ソート状態を保持
      agUserSortItemList.value = getSortItemListDef();
    };

    /**
     * 新規登録ボタン押下
     */
    const showAdd = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // sessionStorageにAG一般ユーザー登録のパラメータ保存
      sessionStorage.setItem(
        AppConstants.AGUSER_REG_SESSION_NAME,
        JSON.stringify({
          agCode: agUserSearchCond.value.agCode,
          processingMode: AppConstants.AG_USER_EDIT_MODE_NEW,
        })
      );

      // AG一般ユーザー登録・変更 登録画面へ遷移
      router.push({
        path: "/aguser-reg",
      });
    };

    /**
     * 編集ボタン押下
     * @param userId ユーザーID
     */
    const showUpdate = (userId: string) => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 対象行取得
      const target = getUserData(userId);
      if (!target) {
        return;
      }

      // sessionStorageにAG一般ユーザー登録のパラメータ保存
      sessionStorage.setItem(
        AppConstants.AGUSER_REG_SESSION_NAME,
        JSON.stringify({
          agCode: target.agCode,
          userId: target.userId,
          processingMode: AppConstants.AG_USER_EDIT_MODE_UPDATE,
        })
      );

      // AG一般ユーザー登録・変更 登録画面へ遷移
      router.push({
        path: "/aguser-reg",
      });
    };

    /**
     * ユーザーIDに該当するユーザー情報を返却します。
     * @param userId ユーザーID
     */
    const getUserData = (userId: string): agUserData | null => {
      const userData = agUserDataList.value.find(
        (userData) => userData.userId == userId
      );
      return userData ? userData : null;
    };

    /**
     * 削除ボタン押下
     */
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // 削除対象絞り込み
      const targetList = agUserDataList.value.filter(
        (agUserData) => agUserData.selection
      );

      // メッセージクリア
      errorMessage.value = "";
      // 選択件数チェック
      if (targetList.length < 1) {
        errorMessage.value = formatMessage(messages.ERR_0003, "明細");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(messages.CNF_0001, "ユーザー", "削除")
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        await apiAuthClient.post("/api/AgUser/deleteAgUser", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value,
          agUserDataList: targetList,
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "ユーザー", "削除"));

        // AG一般ユーザー一覧情報取得
        await getAgUserList();
        // 先頭ページ表示
        currentPage.value = 1;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      // 管理者トップへ遷移
      router.push("/kanrisya-top");
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      if (!isSearchMode.value) {
        // 検索結果表示モードの場合

        // 検索結果クリア
        agUserDataList.value = [];
        // 検索条件入力モードを設定
        processingMode.value = AgUserListConstants.PROCESSING_MODE_SERACH;
      } else {
        // 検索条件入力モードの場合

        // 検索条件クリア
        agUserSearchCond.value = {
          agCode: agCode.value,
          kaisyaName: "",
          busyoName: "",
          tantousyaName: "",
          email: "",
          bikou1: "",
          bikou2: "",
        };
      }
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * ページネーションのデータ生成
     */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return agUserDataList.value.slice(start, end);
    });

    /**
     * 頁総数を取得
     */
    const totalPages = computed(() => {
      return Math.ceil(agUserDataList.value.length / itemsPerPage.value);
    });

    /**
     * ページ切替ハンドラ
     */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
    };

    /**
     * 検索条件入力モード判定
     */
    const isSearchMode = computed(() => {
      return processingMode.value == AgUserListConstants.PROCESSING_MODE_SERACH;
    });

    /**
     * 検索結果のソート処理を行います。
     * @param key ソート項目
     */
    const onSortItem = (key: string) => {
      agUserSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          switch (sortItem.key) {
            case "kaisyaName":
              if (sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
                // 降順
                agUserDataList.value.sort((a, b) =>
                  b.kaisyaName.localeCompare(a.kaisyaName)
                );
              } else {
                // 昇順
                agUserDataList.value.sort((a, b) =>
                  a.kaisyaName.localeCompare(b.kaisyaName)
                );
              }
              break;
            case "busyoName":
              if (sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
                // 降順
                agUserDataList.value.sort((a, b) =>
                  b.busyoName.localeCompare(a.busyoName)
                );
              } else {
                // 昇順
                agUserDataList.value.sort((a, b) =>
                  a.busyoName.localeCompare(b.busyoName)
                );
              }
              break;
            case "tantousyaName":
              if (sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
                // 降順
                agUserDataList.value.sort((a, b) =>
                  b.tantousyaName.localeCompare(a.tantousyaName)
                );
              } else {
                // 昇順
                agUserDataList.value.sort((a, b) =>
                  a.tantousyaName.localeCompare(b.tantousyaName)
                );
              }
              break;
            case "email":
              if (sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
                // 降順
                agUserDataList.value.sort((a, b) =>
                  b.email.localeCompare(a.email)
                );
              } else {
                // 昇順
                agUserDataList.value.sort((a, b) =>
                  a.email.localeCompare(b.email)
                );
              }
              break;
          }

          if (sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
            sortItem.direction = AgUserListConstants.SORT_TYPE_DESC;
          } else {
            sortItem.direction = AgUserListConstants.SORT_TYPE_ASC;
          }
        }
      });
    };

    /**
     * ソート項目の初期値を返却します。
     */
    const getSortItemListDef = () => {
      return [
        {
          key: "kaisyaName",
          direction: AgUserListConstants.SORT_TYPE_ASC,
        },
        {
          key: "busyoName",
          direction: AgUserListConstants.SORT_TYPE_ASC,
        },
        {
          key: "tantousyaName",
          direction: AgUserListConstants.SORT_TYPE_ASC,
        },
        {
          key: "email",
          direction: AgUserListConstants.SORT_TYPE_ASC,
        },
      ];
    };

    /**
     * ソート順が昇順か判定します。
     * @param key ソート項目
     */
    const isDirectionASC = (key: string): boolean => {
      const sortItem = agUserSortItemList.value.find(
        (sortItem) => sortItem.key == key
      );
      if (sortItem && sortItem.direction == AgUserListConstants.SORT_TYPE_ASC) {
        return true;
      }
      return false;
    };

    /**
     * AGコードリストが複数件か判定します。
     */
    const isAgCodeDataListMultiple = computed(() => {
      return agCodeDataList.value.length > 1;
    });

    return {
      errorMessage,
      router,
      isKaunetAdmin,
      agCodeDataList,
      agUserSearchCond,
      agUserDataList,
      onSearch,
      showAdd,
      showUpdate,
      onDelete,
      onBack,
      onClear,
      currentPage,
      itemsPerPage,
      paginatedData,
      totalPages,
      handlePageChange,
      isSearchMode,
      onSortItem,
      isDirectionASC,
      isInitError,
      isAgCodeDataListMultiple,
    };
  },
});
</script>

<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
.col_selection {
  width: 4%;
}
.col_btnUpdate {
  width: 5%;
}
.col_kaisyaName {
  width: 16%;
}
.col_busyoName {
  width: 14%;
}
.col_tantousyaName {
  width: 12%;
}
.col_email {
  width: 23%;
}
.col_bikou1 {
  width: 10%;
}
.col_bikou2 {
  width: 10%;
}
.col_roleDisplayName {
  width: 6%;
}
.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  vertical-align: middle;
}
.form-control-title {
  text-align: right;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
</style>
